// GENERATED FILE — do not edit.
// Synced from api/src/gateway/protocol.ts via `bun run sync:gateway`.
// Edit the source there, then re-run the sync.

// Binary WebSocket framing.
// Frame format: [1 byte type][payload bytes]
// Same format both directions; payload meaning depends on type.
//
// CANONICAL COPY. Mirrors are GENERATED from this file — never edited by hand:
//  - apps/web/src/lib/terminal-protocol.ts   (browser)
//  - apps/desktop/src/shared/protocol.ts     (electron main)
// Keep this file environment-neutral (no Bun/node/Buffer types) so the copies
// are verbatim. Any change here is a wire-protocol change for every client.

export const FRAME = {
  DATA: 0x00, // raw PTY bytes (stdin C→S, stdout/stderr S→C)
  RESIZE: 0x01, // payload = JSON {cols, rows}  (C→S only)
  PING: 0x02, // payload = 8-byte timestamp   (both directions)
  STATUS: 0x03, // payload = JSON {kind, msg}   (S→C: ready, error, closed)
  ACK: 0x04, // payload = 4-byte uint32 of bytes the client rendered (C→S flow control)
} as const;

export interface StatusFrame {
  kind: "ready" | "error" | "closed";
  msg?: string;
  // Machine-readable failure tag, set by the desktop local gateway
  // (credential-denied | agent-unsupported | hostkey-mismatch | unreachable).
  // The api gateway doesn't emit it today; unknown fields are ignored by
  // older parsers, so this is wire-compatible.
  code?: string;
}

export function encode(type: number, payload: Uint8Array | string): Uint8Array {
  const body =
    typeof payload === "string" ? new TextEncoder().encode(payload) : payload;
  const out = new Uint8Array(1 + body.byteLength);
  out[0] = type;
  out.set(body, 1);
  return out;
}

export function decode(buf: ArrayBufferLike | Uint8Array) {
  const u8 =
    buf instanceof Uint8Array ? buf : new Uint8Array(buf as ArrayBufferLike);
  return { type: u8[0], payload: u8.subarray(1) };
}

export function payloadToString(p: Uint8Array): string {
  return new TextDecoder().decode(p);
}
